module.exports = __webpack_public_path__ + "static/media/contract_template_p4.c667ef16.jpg";